import { cn } from '../../lib/cn';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  header?: React.ReactNode;
  headerClassName?: string;
  footer?: React.ReactNode;
  flush?: boolean;
}

export function Card({
  children,
  className,
  contentClassName,
  header,
  headerClassName,
  footer,
  flush,
}: CardProps) {
  return (
    <div
      className={cn(
        'bg-cime-surface rounded-cime border border-neutral-200 shadow-sm flex flex-col',
        className,
      )}
    >
      {header ? (
        <div className={cn('px-5 py-4 border-b border-neutral-200 shrink-0', headerClassName)}>
          {header}
        </div>
      ) : null}
      <div className={cn(flush ? '' : 'px-5 py-4', 'flex-1 min-h-0 flex flex-col', contentClassName)}>
        {children}
      </div>
      {footer ? (
        <div className="px-5 py-4 border-t border-neutral-200 shrink-0">{footer}</div>
      ) : null}
    </div>
  );
}
